import { GridApi, ColumnApi } from 'ag-grid-community';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { EstadoGrilla } from '@/agGridUtil/EstadoGrilla';

export class AgGridUtil {
  private _estadoGrilla: EstadoGrilla;
  controller: string = 'EstadoGrilla';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  readonly axiosPostgres: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  readonly controllerPostgres: string = 'Metabase/PostgenericA';

  constructor(
    private gridApi: GridApi,
    private columnApi: ColumnApi,
    public estadoGrillaVm: EstadoGrillaVm
  ) {}

  async recuperarEstadoGrilla(nombreArchivoPy: string = 'perfil') {
    // try {
    //   const response = await this.axiosPostgres.http.post(
    //     `${this.controllerPostgres}/perfil/getEstadoGrilla`,
    //     {
    //       usuarioId: this.estadoGrillaVm.usuarioId,
    //       funcionalidad: this.estadoGrillaVm.funcionalidades,
    //     }
    //   );
    //   const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, data } = response.data;
    //   const cod: number = Number(CODIGO_RESPUESTA);
    //   if (cod !== 1) throw new Error(MENSAJE_RESPUESTA);
    //   this.estadoGrillaVm = data;
    //   const estadoGrilla: EstadoGrilla = JSON.parse(data.grilla);
    //   this.estadoGrilla = estadoGrilla;
    //   return estadoGrilla;
    // } catch (error) {
    //   console.error('Error: ', error instanceof Error ? error.message : error);
    // }
  }

  get estadoGrilla(): EstadoGrilla {
    this._estadoGrilla = {
      estadoColumna: this.columnApi.getColumnState(),
      estadoGrupo: this.columnApi.getColumnGroupState(),
      estadoOrden: this.gridApi.getSortModel(),
      estadoFiltro: this.gridApi.getFilterModel(),
    };

    return this._estadoGrilla;
  }

  set estadoGrilla(estadoGrilla: EstadoGrilla) {
    this._estadoGrilla = estadoGrilla;

    this.columnApi.setColumnState(estadoGrilla.estadoColumna);
    this.columnApi.setColumnGroupState(estadoGrilla.estadoGrupo);
    this.gridApi.setSortModel(estadoGrilla.estadoOrden);
    this.gridApi.setFilterModel(estadoGrilla.estadoFiltro);
  }

  async guardarEstadoGrilla(nombreArchivoPy: string = ''): Promise<any> {
    this.estadoGrillaVm.grilla = JSON.stringify(this.estadoGrilla);

    if (!nombreArchivoPy) {
      if (this.estadoGrillaVm.id > 0) {
        return this.axios.http
          .put<EstadoGrillaVm>(this.controller, this.estadoGrillaVm, {
            responseType: 'json',
          })
          .then(response => {
            this.estadoGrillaVm = response.data;
            //this.estadoGrilla = JSON.parse(this.estadoGrillaVm.grilla);
          });
      } else {
        return this.axios.http
          .post<EstadoGrillaVm>(this.controller, this.estadoGrillaVm, {
            responseType: 'json',
          })
          .then(response => {
            this.estadoGrillaVm = response.data;
            //this.estadoGrilla = JSON.parse(this.estadoGrillaVm.grilla);
          });
      }
    }
    try {
      const gridStatus = {
        estadoGrillaId: this.estadoGrillaVm.id || 0,
        grilla: this.estadoGrillaVm.grilla,
        currentUserId: this.estadoGrillaVm.usuarioId || 0,
      };

      const response = await this.axiosPostgres.http.post(
        `${this.controllerPostgres}/${nombreArchivoPy}/putEstadoGrilla`,
        { ...gridStatus }
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, data } = response.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) throw new Error(MENSAJE_RESPUESTA);

      this.estadoGrillaVm = data;
    } catch (error) {
      console.error('Error: ', error instanceof Error ? error.message : error);
    }
  }
}
